import { BarChart3, Plus, Zap } from "lucide-react"

interface LoadBalancerHeaderProps {
  onCreateClick: () => void
  onAutoConfigureAll: () => void
  isAutoConfiguring?: boolean
}

export default function LoadBalancerHeader({ onCreateClick, onAutoConfigureAll, isAutoConfiguring = false }: LoadBalancerHeaderProps) {
  return (
    <div className="bg-white rounded-3xl shadow-xl border border-gray-200 p-8 mb-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
            <BarChart3 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">FMO Load Balancer</h1>
            <p className="text-gray-600">Manage traffic distribution across vendor intake forms</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onAutoConfigureAll}
            disabled={isAutoConfiguring}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-200 flex items-center gap-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Zap className="w-5 h-5" />
            {isAutoConfiguring ? "Auto-configuring..." : "Auto-configure All"}
          </button>
          <button
            onClick={onCreateClick}
            className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-200 flex items-center gap-2 shadow-lg"
          >
            <Plus className="w-5 h-5" />
            Create Configuration
          </button>
        </div>
      </div>
    </div>
  )
}
